// extracted by mini-css-extract-plugin
module.exports = {"centered":"Landing_centered__Ce8ZW"};